export function getCookie(cookieName) {
  const emptyString = ''
  const name = `${cookieName}=`
  return document.cookie
    .split(';')
    .map(untrimmedCookie => decodeURIComponent(untrimmedCookie).trim())
    .reduce(
      (acc, curr) => (curr.indexOf(`${name}`) === 0 ? parseIfPossible(curr.substring(name.length, curr.length)) : acc),
      emptyString
    )
}

export function hasCookie(cookieName) {
  return getCookie(cookieName) !== ''
}

export function setCookie(cookieName, cookieValue, options) {
  const inayear = new Date();
  inayear.setTime(inayear.getTime() + 365 * 24 * 60 * 60 * 1000);

  // The following are the Insight default values for the cookie. If options is passed, these are ignored.
  options = options || {
    expires: inayear,
    path: "/",
  };

  ////////// maxage //////////
  let maxage = "";
  if (!!options.maxage) {
    if (!isNaN(options.maxage)) {
      maxage = "; maxage="+options.maxage;
    } else {
      console.warn("maxage should be a number in milliseconds, but found ",typeof(options.maxage)," with value of ",options.maxage)
    }
  }

  ////////// expires //////////
  let expires = "";
  if (!!options.expires) {
    if (options.expires instanceof Date) {
      expires = "; expires="+options.expires.toUTCString();
    } else {
      console.warn("expires should be a Date, but found ",typeof(options.expires)," with value of ",options.expires)
    }
  }

  ////////// domain //////////
  let domain = "";
  if (!!options.domain) {
    domain = "; domain="+options.domain;
  }

  ////////// path //////////
  let path = "";
  if (!!options.path) {
    path = "; path="+options.path;
  }

  ////////// secure //////////
  let secure = "";
  if (!!options.secure) {
    secure = "; secure";
  }

  ////////// samesite //////////
  let samesite = "";
  if (!!options.samesite) {
    if (/strict|lax|none/i.test(options.samesite)) {
      samesite = "; samesite="+options.samesite;
    } else {
      console.warn("samesite values must be 'strict', 'lax' or 'none' but found ",typeof(options.samesite)," with value of ",options.samesite)
    }
  }

  ////////// cookie value //////////
  const value = encodeURIComponent(typeof cookieValue === 'object' ? JSON.stringify(cookieValue) : cookieValue);

  const encodedCookie = `${cookieName}=${value}${maxage}${expires}${domain}${path}${samesite}${secure}`;
  document.cookie = encodedCookie;
}

export function updateCookie(cookieName, editCookieCallback, defaultCookieValue, options) {
  if (hasCookie(cookieName)) {
    const currentCookie = getCookie(cookieName)
    editCookieCallback(currentCookie, options)
  } else {
    setCookie(cookieName, defaultCookieValue, options)
  }
}

function parseIfPossible(value) {
  try {
    return JSON.parse(value)
  } catch (error) {
    return value
  }
}

export function deleteCookie(cookieName){
  const options = {
    expires: new Date('01-10-1970'), // past date as expiry date
    maxage: 0,
    path: '/'
  }
  document.cookie = `${cookieName}=;expires=${options.expires.toUTCString()};maxage=${options.maxage};path=${options.path}`;
}

export function checkForGuestCheckoutCookie(cookieName) {
  if(hasCookie(cookieName)){
    const isCookieAvailable = getCookie(cookieName)
    window.location = isCookieAvailable ? '/insightweb/customerInfo' : '/insightweb/login'
  }else{
    window.location = '/insightweb/login'
  }
}

export function deleteGuestCheckoutCookie(cookieName){
  deleteCookie(cookieName)
}
